@if ((dataSource.loading$ | async) || loading()) {
  <aux-table-skeleton />
}

<div [hidden]="(dataSource.loading$ | async) || loading()">
  <ag-grid-angular
    [id]="idTable"
    class="mb-4 tabular-nums {{ classList }}"
    [ngClass]="{
      'ag-theme-aux': !isAgThemeAlpine && !isAgThemeFlat,
      'ag-theme-alpine': isAgThemeAlpine && !isAgThemeFlat,
      'new-flat-theme': isAgThemeFlat,
    }"
    domLayout="autoHeight"
    [gridOptions]="gridOptions"
    [masterDetail]="masterDetail"
    [isRowMaster]="isRowMaster"
    [detailCellRenderer]="detailCellRenderer"
    [embedFullWidthRows]="embedFullWidthRows"
    [getRowId]="getRowId"
    [context]="getGridContext()"
    [enableFillHandle]="enableFillHandle"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (gridSizeChanged)="gridSizeChanged()"
    (filterChanged)="updateGridLayout()"
    (sortChanged)="onSortChanged()"
    (cellValueChanged)="onCellValueChanged($event)"
    (rowSelected)="onRowSelected($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (modelUpdated)="onModelUpdated($event)"
    auxStickyGrid
  />
</div>

<aux-pagination-panel
  [gridApi]="gridAPI!"
  [paginationPageSize]="gridOptions.paginationPageSize || defaultPaginationSize"
  (paginationChange)="onPaginationChange()"
/>

<!--
  Additional hidden grid for exports
-->
@if (exportGridOptions) {
  <div [hidden]="true">
    <ag-grid-angular class="ag-theme-aux tabular-nums" [gridOptions]="exportGridOptions" />
  </div>
}
